import React from "react";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";

const BellDropdown = ({ notificationCount = 3 }) => {
  const { data: notificationData, refetch } = useQuery({
    queryKey: ["notificationData"],
    queryFn: () => getRequest(`/profile/notification`),
  });

  const markAsReadMutation = useMutation({
    mutationFn: (data) => putRequest("/profile/notification/read", data),
    onSuccess: () => refetch(),
  });

  // New API call when toggling the dropdown
  const toggleDropdownMutation = useMutation({
    mutationFn: () => postRequest("/profile/notification/read-all"), // Call your API
    onSuccess: () => refetch(), // After success, fetch latest notifications
  });

  return (
    <Dropdown
      align="end"
      onToggle={(isOpen) => {
        if (isOpen) {
          toggleDropdownMutation.mutate(); // Call the API when dropdown opens
        }
      }}
    >
      <Dropdown.Toggle as="button" className="btn btn-light border-0 p-2 position-relative new-note-fication">
        {notificationData?.data?.some((n) => !n.isRead) && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "10px", padding: "4px 6px", minWidth: "18px" }}>
            {notificationData.data.filter((n) => !n.isRead).length}
          </span>
        )}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3.44197 5.28299C3.44197 2.69805 5.53748 0.602539 8.12242 0.602539V0.602539V0.602539C10.7074 0.602539 12.8029 2.69805 12.8029 5.28298V7.11446L15.1403 10.231C15.1959 10.3052 15.1742 10.4113 15.094 10.4577V10.4577C10.7812 12.953 5.46364 12.953 1.15084 10.4577V10.4577C1.0706 10.4113 1.04894 10.3052 1.10456 10.231L3.44197 7.11446V5.28299Z" stroke="white" strokeLinejoin="round" />
          <path d="M10.7679 12.151V12.558C10.7679 13.9067 9.67461 15 8.32594 15C6.97728 15 5.88397 13.9067 5.88397 12.558V12.151" stroke="white" />
        </svg>
      </Dropdown.Toggle>

      {Array.isArray(notificationData?.data) && notificationData?.data.length > 0 ? (
        <Dropdown.Menu className="notifyMenu">
          {notificationData?.data.map((ele, index) => {
            // Array of light colors
            const backgroundColors = ["#f8f9fa", "#e9ecef", "#dee2e6", "#d1e7dd", "#cff4fc"];
            const bgColor = backgroundColors[index % backgroundColors.length]; // Cycle through colors

            return (
              <Dropdown.Item
                key={index}
                className="notify"
                onClick={() => markAsReadMutation.mutate({ notificationId: ele?._id })}
                style={{ backgroundColor: bgColor }}
              >
                <div className="notify-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="notify-icon"
                  >
                    <path d="M 12 2 C 11.172 2 10.5 2.672 10.5 3.5 L 10.5 4.1953125 C 7.9131836 4.862095 6 7.2048001 6 10 L 6 16 L 4 18 L 4 19 L 10.269531 19 A 2 2 0 0 0 10 20 A 2 2 0 0 0 12 22 A 2 2 0 0 0 14 20 A 2 2 0 0 0 13.728516 19 L 20 19 L 20 18 L 18 16 L 18 10 C 18 7.2048001 16.086816 4.862095 13.5 4.1953125 L 13.5 3.5 C 13.5 2.672 12.828 2 12 2 z M 12 6 C 14.206 6 16 7.794 16 10 L 16 16 L 16 16.828125 L 16.171875 17 L 7.828125 17 L 8 16.828125 L 8 16 L 8 10 C 8 7.794 9.794 6 12 6 z" />
                  </svg>
                  <div className="notify-content">
                    <strong>{ele?.title}</strong>
                    <br />
                    <span className="notify-body">{ele?.body}</span>
                  </div>
                </div>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      ) :
        (

          <Dropdown.Menu >
            <Dropdown.Item
              className="notify"
            >
             No notifications to show
            </Dropdown.Item>

          </Dropdown.Menu>
        )}

    </Dropdown>
  );
};

export default BellDropdown;